import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import { handleDelete, handleSubmit as modalSubmit } from '../../components/modals/ModalHelpers';
import DynModal from '../../components/modals/DynModal';
import ButtonCard from '../../components/cards/ButtonCard';
import ButtonGroup from '../../components/modals/ButtonGroup';
import InputField from '../../components/form/InputField';
import PagedTable from '../../components/table/PagedTable';
import Bivema from '../../common/Bivema';

const columnsParticipantStatuses = [
  { title: 'Status', name: 'status' },
  { title: 'Edit', name: '_links.self.href' },
];

const defaultParticipantStatus = {
  status: '',
};

const participantStatusValidationSchema = Yup.object().shape({
  status: Yup.string()
    .max(50, 'Darf maximal 50 Zeichen lang sein.')
    .required('Bitte geben Sie einen Status ein.'),
});

const ParticipantStatusOverview = () => {
  const [update, setUpdate] = useState(false);
  const [selfLink, setSelfLink] = useState();
  const [showDynModal, setShowDynModal] = useState(false);
  const [classNameDynModal, setClassNameDynModal] = useState('dynModal');

  const [participantStatus, setParticipantStauses] = useState({
    ...defaultParticipantStatus,
  });

  // needed for formik, to pass it to the modal and set the values
  const formikRef = useRef();

  // set Tab Title
  useEffect(() => {
    document.title = 'Anmeldungs-Status | Stammdaten';
  }, []);

  useEffect(() => {
    if (participantStatus._links !== undefined) {
      setSelfLink(participantStatus._links.self.href);
    }

    // sets formik values
    if (formikRef.current && participantStatus !== formikRef.current.values) {
      formikRef.current.setValues(participantStatus);
    }
  }, [participantStatus]);

  return (
    <div className="container-fluid">
      <ButtonCard title="Anmeldungs-Status" className="mt-2" setShowDynModal={setShowDynModal}>
        <DynModal
          className={classNameDynModal}
          headerTitle="Anmeldungs-Status"
          setEntity={setParticipantStauses}
          defaultEntity={defaultParticipantStatus}
          settersToReset={[setSelfLink]}
          formikRef={formikRef}
          show={showDynModal}
          setShow={setShowDynModal}
          modalBody={(

            <Formik
              innerRef={formikRef}
              initialValues={participantStatus}
              onSubmit={(values, submitProps) => modalSubmit(
                values,
                submitProps,
                setUpdate,
                Bivema.PARTICIPANT_STATUSES,
                selfLink,
              )}
              validateOnChange={false} // because at the moment on change validates all fields
              validationSchema={participantStatusValidationSchema}
            >
              {({
                errors, touched, handleSubmit, handleReset, handleChange, values,
              }) => (
                <Form onSubmit={handleSubmit} onReset={handleReset}>
                  <Modal.Body>
                    <Form.Group controlId="participant-status-group">
                      <InputField
                        value={values.status}
                        handleChange={handleChange}
                        touched={touched.status}
                        errorDescription={errors.status}
                        fieldName="status"
                        placeholder="Status*"
                      />
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonGroup
                      handleDelete={() => handleDelete(selfLink, setUpdate)}
                      selfLink={selfLink !== undefined}
                      setShowDynModal={setShowDynModal}
                      setClassNameDynModal={setClassNameDynModal}
                    />
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
        )}
        />
        <PagedTable
          entityName={Bivema.PARTICIPANT_STATUSES}
          columns={columnsParticipantStatuses}
          pageSize={10}
          setShowDynModal={setShowDynModal}
          setEntity={setParticipantStauses}
          setUpdate={setUpdate}
          update={update}
        />
      </ButtonCard>
    </div>
  );
};

export default ParticipantStatusOverview;
